import { Holiday } from '@mnspro-cloud/services';
import React, { FC, useState } from 'react';
import { EditHolidayComponent } from '../EditHolidayComponent/EditHolidayComponent';
import { HolidayComponent } from '../HolidayComponent/HolidayComponent';

export interface HolidayWithEditComponentProps {
  holiday: Holiday;
  deleteClicked?: (holiday: Holiday) => void;
  updateClicked?: (oldHoliday: Holiday, newHoliday: Holiday) => void;
}

export const HolidayWithEditComponent: FC<HolidayWithEditComponentProps> =
  props => {
    const { holiday, updateClicked, deleteClicked } = props;
    const [isInEditMode, setIsInEditMode] = useState<boolean>(false);

    const handleEditClick = () => setIsInEditMode(true);

    const handleCancelClick = () => setIsInEditMode(false);

    const handleUpdateClicked = (updatedModel: Holiday) => {
      updateClicked?.(holiday, { ...updatedModel, id: holiday.id });
      setIsInEditMode(false);
    };

    const handleDeleteClick = () => {
      deleteClicked?.(holiday);
    };

    if (isInEditMode) {
      return (
        <EditHolidayComponent
          start={holiday.start}
          end={holiday.end}
          name={holiday.name}
          cancelClicked={handleCancelClick}
          updateClicked={handleUpdateClicked}
        />
      );
    }

    return (
      <HolidayComponent
        start={holiday.start}
        end={holiday.end}
        name={holiday.name}
        editClicked={handleEditClick}
        deleteClicked={handleDeleteClick}
      />
    );
  };
